import React, { useState } from "react";
import Card from '@mui/material/Card';
import 'react-toastify/dist/ReactToastify.css';
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { protectedResources } from "../authConfig";
import { HolidaysGrid } from "./HolidaysGrid";
import LoadingSpinner from "./LoadingSpinner";
import ShowToast from '../components/ShowToast.jsx';
import PropTypes from 'prop-types';

export const HolidaysView = ({ administrator }) => {
    HolidaysView.propTypes = {
        administrator: PropTypes.oneOfType([
            PropTypes.shape({
                isAdmin: PropTypes.bool,
            }),
            PropTypes.oneOf([null])
        ])
    };

    const { error, isLoading, execute } = useFetchWithMsal({
        scopes: protectedResources.api.scopes
    });

    if (error) {
        ShowToast("error", error?.message);
    }

    const renderForm = (
        <Card variant="outlined">
            {administrator?.isAdmin && (
                <>
                    <h2 className="tituloH2 mt-3">Registro de días feriados</h2>
                    <HolidaysGrid />
                </>
            )}
        </Card>
    );

    return (
        <div className="container"> {isLoading ? <LoadingSpinner /> : renderForm}</div>
    );
}
